import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import useAuth from '../../../auth/useAuth';

// Up to two initials from a name: "Julia Munroe" → "JM", "Spice" → "SP".
const initialsOf = (name = '') => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

// Restaurant and plan, pinned to the foot of the sidebar. The round button
// shrinks the sidebar to its icon rail and back, as the header toggle does; on
// the rail the card stacks to that button (⋮) over the initials.
export default function SidebarUserCard() {
  const { user } = useAuth();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const restaurant = user?.restaurant;
  const name = restaurant?.name || user?.user?.name;
  if (!name) return null;

  const planName = restaurant?.subscription?.plan_name;

  return (
    <div className="sidebar-user-card">
      <span className="sidebar-user-card-avatar" title={name}>
        {initialsOf(name)}
      </span>
      <div className="sidebar-user-card-text">
        <div className="sidebar-user-card-name">{name}</div>
        {planName && <div className="sidebar-user-card-plan">{planName}</div>}
      </div>
      <button
        type="button"
        className="sidebar-user-card-toggle"
        aria-label={drawerOpen ? 'Expand sidebar' : 'Shrink sidebar'}
        onClick={() => handlerDrawerOpen(!drawerOpen)}
      >
        <i className="ph ph-list-bullets sidebar-user-card-toggle-full" />
        <i className="ph ph-dots-three-vertical sidebar-user-card-toggle-rail" />
      </button>
    </div>
  );
}
